var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-chart"},[_c('div',{staticClass:"pie-chart__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('Pie',{attrs:{"chartData":_vm.chartData,"chartOptions":_vm.chartOptions,"chartId":_vm.chartId,"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }